// extracted by mini-css-extract-plugin
module.exports = {"back":"ApartmentsGroups_back_1TYOS","header":"ApartmentsGroups_header_gksmZ","aside":"ApartmentsGroups_aside_3ZuHN","empty":"ApartmentsGroups_empty_1Qd4k"};